import React from 'react';

// Estilos globales (caja_status_2…) que todavía usan otras vistas
import "./Solicitud.css"

import DetalleSolicitud from '../../Compartidas/DetalleSolicitud';

import reinscripcionesDataHelper from '../../../Helpers/ReinscripcionesData';
import { LICENCIATURAS_REINSCRIPCION, etiquetaLicenciatura } from '../../../Helpers/solicitudes';

const siNo = (tiene, detalle) => (tiene ? detalle || 'Sí' : 'No');

const SECCIONES = [
    {
        titulo: 'Alumno',
        campos: [
            { etiqueta: 'Licenciatura', valor: s => etiquetaLicenciatura(LICENCIATURAS_REINSCRIPCION, s.licenciatura) },
            { etiqueta: 'Cuatrimestre', valor: s => s.cuatrimestre },
            { etiqueta: 'Grupo', valor: s => s.grupo },
            { etiqueta: 'Periodo escolar', valor: s => s.periodo }
        ]
    },
    {
        titulo: 'Contacto',
        campos: [
            { etiqueta: 'Celular', valor: s => s.celular, tipo: 'telefono' },
            { etiqueta: 'Correo', valor: s => s.email, tipo: 'correo' }
        ]
    },
    {
        titulo: 'Domicilio',
        campos: [
            { etiqueta: 'Calle y número', valor: s => s.domicilio },
            { etiqueta: 'Colonia', valor: s => s.colonia },
            { etiqueta: 'Código postal', valor: s => s.codigoPostal },
            { etiqueta: 'Ciudad', valor: s => s.ciudad },
            { etiqueta: 'Estado', valor: s => s.estado },
            { etiqueta: 'País', valor: s => s.pais }
        ]
    },
    {
        titulo: 'Familia',
        campos: [
            { etiqueta: 'Madre', valor: s => s.nombreMadre },
            { etiqueta: 'Teléfono de la madre', valor: s => s.telefonoMadre, tipo: 'telefono' },
            { etiqueta: 'Padre', valor: s => s.nombrePadre },
            { etiqueta: 'Teléfono del padre', valor: s => s.telefonoPadre, tipo: 'telefono' }
        ]
    },
    {
        titulo: 'Trabajo',
        campos: [
            { etiqueta: 'Empresa', valor: s => s.empresa },
            { etiqueta: 'Domicilio de la empresa', valor: s => s.domicilioEmpresa },
            { etiqueta: 'Teléfono de la empresa', valor: s => s.telefonoEmpresa, tipo: 'telefono' }
        ]
    },
    {
        titulo: 'Salud y pago',
        campos: [
            { etiqueta: 'Condición especial', valor: s => siNo(s.condicion, s.condicionEspecial) },
            { etiqueta: 'Enfermedad crónica', valor: s => siNo(s.enfermedad, s.enfermedadEspecificacion) },
            { etiqueta: '¿Cómo liquida el cuatrimestre?', valor: s => s.pago }
        ]
    }
];

const Solicitud = () => (
    <DetalleSolicitud
        helper={reinscripcionesDataHelper}
        etiqueta='Solicitud de reinscripción'
        licenciaturas={LICENCIATURAS_REINSCRIPCION}
        secciones={SECCIONES}
        rutaActivas='/solicitud-reinscripciones'
        rutaArchivo='/archivos-reinscripciones'
    />
);

export default Solicitud;
